import FraudIndicatorsActivator from './FraudIndicatorsActivator'

export default FraudIndicatorsActivator
